import React from "react";

const Icon3: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="transparent"
      viewBox="0 0 24 25"
    >
      <path
        fill="currentColor"
        d="M22.573 8.133l-4.8 2.24-3.106-3.106V5.4l3.106-3.107 4.8 2.24c.507.24 1.094.014 1.334-.48a1.004 1.004 0 00-.48-1.333L18.2.28a1.324 1.324 0 00-1.507.267l-2.32 2.32a1.3 1.3 0 00-1.04-.534c-.733 0-1.333.6-1.333 1.334V5H7.76C7.2 3.453 5.733 2.333 4 2.333c-2.213 0-4 1.787-4 4C0 7.8.8 9.067 1.973 9.773L5.44 21H4a2.674 2.674 0 00-2.667 2.667V25h17.334v-1.333C18.667 22.2 17.467 21 16 21h-2.16L7.213 8.693c.227-.32.414-.653.547-1.026H12V9c0 .733.6 1.333 1.333 1.333a1.3 1.3 0 001.04-.533l2.32 2.32c.4.4 1 .507 1.507.267l5.227-2.44a.993.993 0 00.48-1.334 1.004 1.004 0 00-1.334-.48zM4 7.667c-.733 0-1.333-.6-1.333-1.334C2.667 5.6 3.267 5 4 5s1.333.6 1.333 1.333c0 .734-.6 1.334-1.333 1.334zM10.813 21H8.227l-3.28-10.667h.133L10.813 21z"
      ></path>
    </svg>
  );
}

export default Icon3;
